import { createStore } from 'redux';

const initialState = {
  time: 0,
  animationEnabled: true,
  gradients: {
    primary: {
      hue: 152,
      saturation: 40,
      lightness: 54,
    },
    secondary: {
      hue: 192,
      saturation: 40,
      lightness: 54,
    },
  },
  settings: {
    speedScale: 0.24,
    gradSpanDeg: 100,
    satBase: 79,
    satAmp: 21,
    satFreq: 30,
    lightBase: 50,
    lightAmp: 18,
    lightFreq: 25,
  },
};

// Reducer for gradient state
function gradientReducer(state = initialState, action) {
  switch (action.type) {
    case 'INCREMENT_GRADIENT':
      return {
        ...state,
        time: state.time + 1,
      };

    case 'UPDATE_SETTINGS':
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.payload,
        },
      };

    case 'TOGGLE_ANIMATION':
      return {
        ...state,
        animationEnabled: action.payload,
      };

    default:
      return state;
  }
}

// Create and export the store
export const gradientStore = createStore(gradientReducer);

// Unified gradient system: 2 stops, variable span, oscillating S/L
export const getGradientColors = state => {
  const { time, settings } = state;
  const { floor } = Math;

  // Calculate background colors from time-based state using speed settings
  const speed = settings.speedScale || 0.24;
  const bg = {
    h: (time * 0.01 * speed) % 360,
    s: Math.sin(time * 0.02 * speed + 1) / 2,
    l: Math.sin(time * 0.015 * speed + 1) / 2,
  };

  // Base hue and oscillating saturation/lightness
  const baseHue = floor(bg.h * 360);
  const sat = settings.satBase + (Math.sin(bg.s * settings.satFreq) / 2) * settings.satAmp;
  const light = settings.lightBase + (Math.sin(bg.l * settings.lightFreq) / 2) * settings.lightAmp;
  const spanDeg = Math.max(1, Math.min(359, settings.gradSpanDeg));

  // Two stops: start and peek ahead by spanDeg
  const primaryColor = {
    h: baseHue % 360,
    s: Math.round(sat),
    l: Math.round(light),
  };

  const peekColor = {
    h: (baseHue + spanDeg) % 360,
    s: Math.round(sat),
    l: Math.round(light),
  };

  return { primaryColor, peekColor };
};

// Nav gradient helper - uses unified color system
export const getNavGradient = state => {
  const { primaryColor, peekColor } = getGradientColors(state);

  return `linear-gradient(90deg, hsl(${primaryColor.h}, ${primaryColor.s}%, ${primaryColor.l}%) 0%, hsl(${peekColor.h}, ${peekColor.s}%, ${peekColor.l}%) 100%)`;
};
